import Vue from "vue";
import "normalize.css";
import "@/styles/index.scss";
import ElementUI from "element-ui";
import "@/styles/element-variables.scss";
import VueClipboard from 'vue-clipboard2';
import SvgIcon from "vue-svgicon";
import eventEmitter from "@/utils/eventEmitter";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/permission"; // 引用路由守卫鉴权配置
import directives from "@/utils/directives";
import "@/icons/components";
// 阻止打印生产环境提示信息
Vue.config.productionTip = false;
// 引用elementUI组件库
Vue.use(ElementUI);
// 引用复制组件
Vue.use(VueClipboard);
// 引用svg图标组件
Vue.use(SvgIcon, {
    tagName: "svg-icon",
    defaultWidth: "1em",
    defaultHeight: "1em",
});
Object.entries(directives).forEach(([key, value]) => {
    Vue.directive(key, value);
});
router.beforeEach((to, from, next) => {
    // 将路由事件都放到消息队列里处理
    eventEmitter.next = next;
    eventEmitter.from = from;
    eventEmitter.to = to;
});
new Vue({
    router,
    store,
    render: (h) => h(App),
    beforeCreate: () => {
        Vue.prototype.$bus = new Vue();
    }
}).$mount("#app");
